"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
require("../v2/MailingAddress/index.scss");
const contexts_1 = require("@App/contexts");
const react_hook_form_1 = require("react-hook-form");
const mailing_address_form_1 = require("@App/forms/common/mailing-address-form");
const FormFieldFromProps_1 = __importDefault(require("@App/kit/fields/FormFieldFromProps"));
const utils_1 = require("@App/common/utils");
const mobx_react_1 = require("mobx-react");
const MailingAddress = (props) => {
    const { libStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const { watch } = (0, react_hook_form_1.useFormContext)();
    const { title = 'Mailing Address', toolTip, subSection, optional } = props;
    const [mailingAddressFormProps, setMailingAddressFormProps] = (0, react_1.useState)(props.mailingAddressFormProps);
    const [addressIsOptional, setAddressIsOptional] = (0, react_1.useState)(!!optional);
    const countryValue = watch(mailingAddressFormProps.country.name);
    (0, react_1.useEffect)(() => {
        const isUSA = (0, utils_1.isCountryUS)(countryValue);
        const isCanada = (0, utils_1.isCountryCAN)(countryValue);
        const formFields = (0, mailing_address_form_1.modifyMailingAddressFormProps)(mailingAddressFormProps, (0, utils_1.isPostcodeRequiredCountry)(countryValue), isUSA, isCanada, libStore.statesForCountryForForm(countryValue));
        setMailingAddressFormProps(Object.assign({}, formFields));
    }, [countryValue]);
    if (optional) {
        const cityValue = watch(mailingAddressFormProps.city.name);
        const streetValue = watch(mailingAddressFormProps.streetAddress.name);
        const unitValue = watch(mailingAddressFormProps.unitNumber.name);
        const stateValue = watch(mailingAddressFormProps.state.name);
        const postalCodeValue = watch(mailingAddressFormProps.postalCode.name);
        (0, react_1.useEffect)(() => {
            const isThereAddressValue = !!cityValue || !!streetValue || !!unitValue || !!stateValue || !!postalCodeValue;
            setAddressIsOptional(!isThereAddressValue);
        }, [cityValue, streetValue, unitValue, stateValue, postalCodeValue, countryValue]);
        (0, react_1.useEffect)(() => {
            const formFields = (0, mailing_address_form_1.markFieldsAsRequired)(mailingAddressFormProps, addressIsOptional);
            setMailingAddressFormProps(Object.assign({}, formFields));
        }, [addressIsOptional]);
    }
    const { streetAddress, unitNumber, attention, city, state, postalCode, country } = mailingAddressFormProps;
    country.options = libStore.countries;
    return (react_1.default.createElement("div", { className: "mailing-address-wrapper" },
        react_1.default.createElement("h5", null,
            title,
            (0, react_1.isValidElement)(toolTip) && toolTip),
        subSection && subSection,
        react_1.default.createElement("div", { className: "mailing-address" },
            react_1.default.createElement(FormFieldFromProps_1.default, Object.assign({}, streetAddress)),
            react_1.default.createElement(FormFieldFromProps_1.default, Object.assign({}, unitNumber)),
            !!attention && react_1.default.createElement(FormFieldFromProps_1.default, Object.assign({}, attention)),
            react_1.default.createElement(FormFieldFromProps_1.default, Object.assign({}, city)),
            react_1.default.createElement(FormFieldFromProps_1.default, Object.assign({}, country)),
            react_1.default.createElement(FormFieldFromProps_1.default, Object.assign({}, state)),
            react_1.default.createElement(FormFieldFromProps_1.default, Object.assign({}, postalCode)))));
};
exports.default = (0, mobx_react_1.observer)(MailingAddress);
